import React from "react";
import * as d3 from "d3";
import PropTypes from "prop-types";
import { playingAreaConfig } from "./utils.js";

const HeatMap = (props) => {
  let height = props.height;
  let width = props.width;

  return (
    <g mask={`url(#maskIs${props.isLandscape ? "" : "Not"}Landscape)`}>
      {d3
        .contourDensity()
        .x((d) => props.x(parseInt(d[props.isLandscape ? "x" : "y"])))
        .y((d) => props.y(parseInt(d[props.isLandscape ? "y" : "x"])))
        .size(props.isLandscape ? [width, height] : [height, width])
        .bandwidth(playingAreaConfig[props.sport].heatMapBandwidth || 20)(
          props.data
        )
        .map((contour, i) => (
          <path
            key={i}
            d={d3.geoPath()(contour)}
            fill={d3
              .scaleLinear()
              .domain(playingAreaConfig[props.sport].heatMapDomain)
              .range(props.range)(contour.value)}
          />
        ))}
    </g>
  );
};

HeatMap.defaultProps = {
  data: [],
  height: 0,
  isLandscape: true,
  range: [
    "rgba(0, 0, 255, 0.05)",
    "rgba(255, 255, 0, 0.5)",
    "rgba(255, 0, 0, 0.5)"
  ],
  sport: "soccer",
  x: d3.scaleLinear().domain([0, 100]),
  y: d3.scaleLinear().domain([0, 100]),
  width: 0
};

HeatMap.propTypes = {
  data: PropTypes.array,
  height: PropTypes.number,
  isLandscape: PropTypes.bool,
  range: PropTypes.array,
  sport: PropTypes.string,
  x: PropTypes.func,
  y: PropTypes.func,
  width: PropTypes.number
};

export default HeatMap;
